import { Link as RouterLink } from 'react-router-dom';
import { raisedPanelSx } from '@/shared/ui/panelShadowStyles';
import { s } from '@/theme/tokens';
import { Box, Button, Panel, Stack, Text } from '@/ui';
import { Section } from '@/ui/layout/Section';
import { PageShell } from '@/ui/primitives/PageShell';
import type { ReactElement } from 'react';

type UnauthorizedScreenProps = {
  title?: string;
  body?: string;
  backTo?: string;
  backLabel?: string;
};

export const UnauthorizedScreen = ({
  title = 'Unauthorised',
  body = 'You do not have permission to view this page.',
  backTo = '/',
  backLabel = 'Go Back',
}: UnauthorizedScreenProps): ReactElement => (
  <PageShell maxWidth="xs" paddingX="lg" paddingY="xl" paddingBottom="xl">
    <Stack gap="xl" sx={{ pt: s('5xl') }}>
      <Section>
        <Box sx={{ width: '100%' }}>
          <Panel
            title={title}
            titleSx={{ textAlign: 'center', width: '100%' }}
            actionsAlign="center"
            actions={
              <Button component={RouterLink} to={backTo} variant="primary">
                {backLabel}
              </Button>
            }
            sx={raisedPanelSx}
          >
            <Text role="bodyMuted" align="center">
              {body}
            </Text>
          </Panel>
        </Box>
      </Section>
    </Stack>
  </PageShell>
);
